import { IconProps } from '@mui/material'
import React from 'react'

const Expand: React.FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 16 16" fill="none">
      <path
        d="M6.74286 5.94502C6.96329 6.16546 6.96329 6.52205 6.74286 6.74249C6.52242 6.96292 6.16583 6.96292 5.94539 6.74249L3.1825 3.97959V5.51585C3.1825 5.8271 2.9304 6.0798 2.61854 6.0798C2.30669 6.0798 2.05459 5.8271 2.05459 5.51585V2.61817C2.05459 2.30644 2.30924 2.05422 2.61854 2.05422H5.51622C5.82808 2.05422 6.08017 2.30693 6.08017 2.61817C6.08017 2.92942 5.82808 3.18213 5.51622 3.18213H3.97996L6.74286 5.94502Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M13.9453 10.4813V13.379C13.9453 13.6884 13.6926 13.943 13.3813 13.943H10.4837C10.1719 13.943 9.91971 13.6908 9.91971 13.379C9.91971 13.0673 10.1719 12.8151 10.4837 12.8151H12.0199L9.25703 10.0522C9.03659 9.83173 9.03659 9.47514 9.25703 9.2547C9.47746 9.03427 9.83405 9.03427 10.0545 9.2547L12.8174 12.0176V10.4813C12.8174 10.1696 13.0696 9.91739 13.3813 9.91739C13.6931 9.91739 13.9453 10.1696 13.9453 10.4813Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M13.9453 2.61817V5.51585C13.9453 5.8271 13.6932 6.0798 13.3813 6.0798C13.0695 6.0798 12.8174 5.8271 12.8174 5.51585V3.97959L10.0545 6.74249C9.83405 6.96292 9.47746 6.96292 9.25703 6.74249C9.03659 6.52205 9.03659 6.16546 9.25703 5.94502L12.0199 3.18213H10.4837C10.1718 3.18213 9.91971 2.92942 9.91971 2.61817C9.91971 2.30693 10.1718 2.05422 10.4837 2.05422H13.3813C13.6878 2.05422 13.9453 2.30442 13.9453 2.61817Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M6.74286 9.2547C6.96329 9.47514 6.96329 9.83173 6.74286 10.0522L3.97996 12.8151H5.51622C5.82798 12.8151 6.08017 13.0673 6.08017 13.379C6.08017 13.6908 5.82798 13.943 5.51622 13.943H2.61854C2.3062 13.943 2.05459 13.6877 2.05459 13.379V10.4813C2.05459 10.1696 2.30678 9.91739 2.61854 9.91739C2.9303 9.91739 3.1825 10.1696 3.1825 10.4813V12.0176L5.94539 9.2547C6.16583 9.03427 6.52242 9.03427 6.74286 9.2547Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
    </svg>
  )
}

export default Expand
